module.exports = __webpack_public_path__ + "img/check-r-k.eb489842.svg";